<template>
  <div id="apply_chackout">
    <div class="centered">
        <div class="head">
            <h2>תשלום להצעת מכרז</h2>
            <router-link :to="{ name: 'projects' }" class="exit_btn">חזרה לרשימת מכרזים</router-link>
        </div>
        <div class="content">
            <div class="desc" v-html="get_word('apply_chackout_desc')"></div>
            <form  v-if="!showPayment" @submit.prevent="addNames" class="name_form">
                <h5>פרטים לקבלה</h5>
                <ul>
                    <li>
                        <label for="">שם פרטי</label>
                        <input type="text" name="first_name" v-model="nameForm.first_name">
                    </li>
                    <li>
                        <label for="">שם משפחה</label>
                        <input type="text" name="last_name" v-model="nameForm.last_name">
                    </li>
                    <li>
                        <label for="">איימיל</label>
                        <input type="email" name="email" v-model="nameForm.email">
                    </li>
                </ul>
                <input type="submit" class="btn" value="שליחה" />
            </form>
            <Payment v-else :paymentData="paymentData" @payment_success="handlePaymentSuccess" @fail_msg="failMsg" @fail="fail" />
        </div>
    </div>
  </div>
</template>

<script>
import Payment from '@/components/Payment.vue';
export default {
    components: { Payment },
    data() {
        return {
            order_token: (this.$route.params.order_token ? this.$route.params.order_token : false),
            apply_token: (this.$route.params.apply_token ? this.$route.params.apply_token : false),
            paymentData: {},  
            showPayment: false,
            nameForm: {
                first_name: '',
                last_name: '',
                email: ''
            }
        }
    },
    beforeMount() {
        const [first_name, last_name] = this.get_me().name.split(' ');
        this.nameForm.first_name = first_name;
        this.nameForm.last_name = last_name;
        this.nameForm.email = this.get_me().username;
    },
    mounted() {
        // this.createPayment()
    },
    methods: {
        addNames() {
            this.api({ action: 'order/update', data: { token: this.order_token, ...this.nameForm}}, (data) => {
              if (data.data) {
                this.createPayment()
              } else {
                alert('שגיאה בשמירת הנתונים');
              }
            })
        },
        failMsg(msg) {
            alert(msg);
        },
        fail() {
            alert('תשלום נכשל');
        },
        handlePaymentSuccess() {
            this.confirm(this.get_word('payment_success'), "המשך להגשת הצעה למכרז","חזור לרשימת מכרזים").then((result) => {
                if (result) {
                    this.$router.push({ name: 'applying_project', params: { token: this.apply_token, step: 1 }})
                } else {
                    this.$router.push({ name: 'projects' })
                }
            });
            
            // alert('תשלום בוצע בהצלחה');
            // this.$router.push({ name: 'projects' });
        },
        createPayment() {
            this.api({ action: 'create_payment', data: { order_id: this.order_token }}, (obj) => {
              this.paymentData.id = obj.data.id;
              this.paymentData.price = obj.data.price;

              this.paymentData.first_name = this.nameForm.first_name;
              this.paymentData.last_name = this.nameForm.last_name;
              this.paymentData.email = this.nameForm.email;
              this.paymentData.invoice_name = this.nameForm.first_name + ' ' + this.nameForm.last_name;
              
              this.showPayment = true;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
#apply_chackout {
    
    .head {display: flex; justify-content: space-between; 
      h2 {color: var(--title_color); font-size: var(--h2);}
      .exit_btn { display: flex; align-items: center; justify-content: center; border-radius: 12px; border: 1px solid var(--text_s); color: var(--dark_blue); padding: 8px 16px;}
      
    }
    .content { margin-top: var(--gap_big); display: flex; flex-direction: column; gap: var(--gap_big);
        .name_form { display: flex; flex-direction: column; gap: var(--gap);
            ul { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; }
        }
    }
}
</style>